/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * the type of additional
 * @export
 */
export const AdditionalType = {
    Check: 'CHECK',
    Print: 'PRINT',
    Shipping: 'SHIPPING',
    License: 'LICENSE'
} as const;
export type AdditionalType = typeof AdditionalType[keyof typeof AdditionalType];


export function AdditionalTypeFromJSON(json: any): AdditionalType {
    return AdditionalTypeFromJSONTyped(json, false);
}

export function AdditionalTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalType {
    return json as AdditionalType;
}

export function AdditionalTypeToJSON(value?: AdditionalType | null): any {
    return value as any;
}

